<template>

	<app-boards board-key="sw_examples"></app-boards>

</template>

<script>
import AppBoards from "../../components/boards/appBoards";
export default {
	name: "sw_examples",
	components: {AppBoards}
}
</script>

<style scoped>

</style>